/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `wpt` - Protect & Trace
 * * `wcmnb` - Wolf Connect (MNB)
 * * `wcwwan` - Wolf Connect (WWAN)
 * * `iso` - Isolation
 * * `mon` - Monitoring
 * * `cred_prot` - Credential Protection
 * * `prot_apps` - Protected Apps
 * * `thin_cli` - Thin Client
 * * `signed_set` - Signed Settings
 * @export
 */
export const LicensableCharacteristic = {
    Wpt: 'wpt',
    Wcmnb: 'wcmnb',
    Wcwwan: 'wcwwan',
    Iso: 'iso',
    Mon: 'mon',
    CredProt: 'cred_prot',
    ProtApps: 'prot_apps',
    ThinCli: 'thin_cli',
    SignedSet: 'signed_set'
} as const;
export type LicensableCharacteristic = typeof LicensableCharacteristic[keyof typeof LicensableCharacteristic];


export function LicensableCharacteristicFromJSON(json: any): LicensableCharacteristic {
    return LicensableCharacteristicFromJSONTyped(json, false);
}

export function LicensableCharacteristicFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicensableCharacteristic {
    return json as LicensableCharacteristic;
}

export function LicensableCharacteristicToJSON(value?: LicensableCharacteristic | null): any {
    return value as any;
}

